<template>
    <form class="form form-vertical">
      <div class="form-body">
        <div class="row">
          <!-- Name -->
          <vx-input-group class="mb-5">          
            <vs-input
              label="Nome da Categoria"
              v-model="category.name"
              class="w-full"
              name="nome"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('nome')"
            >
              {{ errors.first('nome') }}
            </span>
          </vx-input-group>
  
          <!-- Color Tag -->
          <div class="flex">
            <vx-input-group class="mb-5">
              <label class="vs-input--label">Selecione uma Etiqueta</label>
              <div class="items-center">
                <div class="relative ml-3">
                  <vs-dropdown class="flex" vs-trigger-click vs-custom-content> 
                      <vs-icon icon="label" size="large" :color="category.color_tag"></vs-icon>
                      <feather-icon
                        size="large"
                        icon="EditIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current mt-3"
                      />
    
                    <vs-dropdown-menu >
                      <div class="rounded-md bg-white shadow-xs px-4 py-3 ">
                        <div class="grid grid-cols-4 gap-4 gap-4">
                          <div v-for="(color, index) in colors" :key="index" >
                            <template v-if="category.color_tag === color">	
                              <div
                                class="w-8 h-8 inline-block rounded-full cursor-pointer border-4 border-white"
                                :style="`background: ${color}; box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.2);`"
                              ></div>
                            </template>
    
                            <template v-if="category.color_tag !== color">
                              <div
                                role="checkbox"
                                tabindex="0"
                                @click="category.color_tag = color"
                                :aria-checked="category.color_tag"	
                                class="w-8 h-8 inline-block rounded-full cursor-pointer border-4 border-white focus:outline-none focus:shadow-outline"
                                :style="`background: ${color};`"
                              ></div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </div>
            </vx-input-group>
          </div>

          <vx-input-group>
            <div class="w-full d-flex justify-content-flex-end">
              <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || !category.name">
                Salvar
              </vs-button>
            </div>
          </vx-input-group>
        </div>
      </div>
    </form>
  </template>
  
  <script>
  
  import Pagination from "@/components/pagination/pagination.vue";
  
  import { AgGridVue } from "ag-grid-vue"
  import { formatRouteTenantPath } from '@/utils'

  import moduleRelationshipRuleCategory from '@/store/relationshipRuleCategory/moduleRelationshipRuleCategory'
  
  import 'ag-grid-community/dist/styles/ag-grid.css';
  import 'ag-grid-community/dist/styles/ag-theme-balham.css';
  
  export default {
      name: 'category-add',
      data() {
        return {
          category: {
            name: '',
            color_tag: ''
          },
          colors: [
            '#ffa12f','#ff5722','#b60ca0','#e50950',
            '#6c1a54','#0491FF','#0235cc','#3f5fd0',
            '#423572','#08e0ae','#07a092','#1db954',
            '#0b6509','#6d7c21','#52391c','#757380'
          ]
        }
      },
      computed: {
        isFormValid() {
          return !this.errors.any()
        },
      },
      methods: {
        async submitData() {
            if(!this.category.color_tag){
                return this.$vs.notify({
                    title: "Erro",
                    text: "Necessário escolher uma cor",
                    color: "danger",
                });
            }
            const data = { name: this.category.name, color_tag: this.category.color_tag }
            await this.$store.dispatch("relationshipRuleCategory/add", data)
            .then(() => {
                this.$vs.notify({
                      title: "Sucesso",
                      text: "Categoria adicionada com sucesso",
                      color: "success",
                  });
                return this.$router.push(formatRouteTenantPath(`/messaging/relationship-rules-categories`))
            })
            .catch((error) => {
                console.error(error);
            });
        },
      },
      created() {
        if (!moduleRelationshipRuleCategory.isRegistered) {
            this.$store.registerModule('relationshipRuleCategory', moduleRelationshipRuleCategory)
            moduleRelationshipRuleCategory.isRegistered = true
        }
      },
      components: {
        Pagination,
        AgGridVue
      }
    }
  </script>
  
  <style scoped>
  button.button-remove-bg {
    color: #0B8FFA !important;
  }
  
  #button-update {
    width: 1em;
    transform: translateY(-0.3em);
  }
  </style>
  